import { render } from "./VerticalSidebar.vue?vue&type=template&id=05d95fe5&scoped=true"
import script from "./VerticalSidebar.vue?vue&type=script&lang=js"
export * from "./VerticalSidebar.vue?vue&type=script&lang=js"

import "./VerticalSidebar.vue?vue&type=style&index=0&id=05d95fe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d95fe5"]])

export default __exports__